import { useAuthStore, useLogoutMutation } from '@host/auth'
import { Avatar, Button, Input, Menu, useTheme } from '@prismeet/react'
import { useNavigate } from 'react-router'

import { profilePath } from '@/app/router/constants'
import { MenuIcon, MoonIcon, SearchIcon, SunIcon } from '@/shared/icons'
import { useAppUiStore } from '@/shared/stores/appUiStore'

import {
  LOGOUT_LABEL,
  OPEN_SIDEBAR_LABEL,
  PROFILE_MENU_LABEL,
  SEARCH_PLACEHOLDER,
  THEME_TOGGLE_LABEL,
} from './constants'
import styles from './index.module.scss'

export function AppTopBar() {
  const navigate = useNavigate()
  const user = useAuthStore((state) => state.session?.user)
  const setSidebarOpen = useAppUiStore((state) => state.setSidebarOpen)
  const setSettingsOpen = useAppUiStore((state) => state.setSettingsOpen)
  const logout = useLogoutMutation()
  const { resolvedTheme, toggleTheme } = useTheme()

  return (
    <header className={styles.topBar}>
      <Button
        iconOnly
        variant="ghost"
        aria-label={OPEN_SIDEBAR_LABEL}
        className={styles.menuButton}
        onClick={() => {
          setSidebarOpen(true)
        }}
      >
        <MenuIcon />
      </Button>

      <div className={styles.topBarSearch}>
        <Input
          type="search"
          variant="soft"
          size="sm"
          placeholder={SEARCH_PLACEHOLDER}
          iconStart={<SearchIcon />}
          aria-label={SEARCH_PLACEHOLDER}
          fullWidth
        />
      </div>

      <Button
        iconOnly
        variant="ghost"
        aria-label={THEME_TOGGLE_LABEL[resolvedTheme]}
        onClick={toggleTheme}
      >
        {resolvedTheme === 'dark' ? <SunIcon /> : <MoonIcon />}
      </Button>

      <Menu
        label={PROFILE_MENU_LABEL}
        variant="ghost"
        icon={
          <Avatar
            name={user?.displayName ?? 'Профиль'}
            src={user?.avatarUrl ?? undefined}
            size="sm"
            labelledOutside
          />
        }
        items={[
          {
            label: 'Мой профиль',
            onSelect: () => {
              void navigate(profilePath(user?.username ?? 'me'))
            },
          },
          {
            // Модалка в стиле Discord: URL не меняется, экран под ней
            // остаётся смонтированным. Служебная страница /settings
            // по-прежнему доступна из левой навигации.
            label: 'Настройки',
            onSelect: () => {
              setSettingsOpen(true)
            },
          },
          { kind: 'separator' },
          {
            label: LOGOUT_LABEL,
            tone: 'danger',
            onSelect: () => {
              logout.mutate()
            },
          },
        ]}
      />
    </header>
  )
}
